module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-28.3e7543d7.svg";